import { DimensionsUI } from "./DimensionsUI";
import { StandardProps } from "../componentMap";
import {
  formatProductTypeForDimensions,
  largeElecSellingTypes,
} from "./dimensionsUtils";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { getAttributeValues } from "../../utils/product/getAttributeValues";
import { getAttributeValuesFromHierarchy } from "../../utils/product/getAttributeValuesFromHierarchy";

export function Dimensions({ product }: Pick<StandardProps, "product">) {
  const { variant } = useVariant(product);
  const variantAttributes = variant.attributes;

  // Only render for large electrical products and televisions
  if (
    !product.sellingProductType ||
    !largeElecSellingTypes.includes(product.sellingProductType)
  ) {
    return null;
  }

  const productType = formatProductTypeForDimensions(
    product.sellingProductType,
  );

  const dimensions = getAttributeValuesFromHierarchy(
    "dimensions",
    product.attributes,
    variantAttributes ?? [],
  );

  // aperture only exists in product level attributes
  const aperture = getAttributeValues(
    "combinedaperturedimensions",
    product.attributes,
  );

  return (
    <DimensionsUI
      productType={productType}
      dimensions={dimensions[0]}
      aperture={aperture[0]}
    />
  );
}
